
import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api/index';
@Component
export default class Rule extends Vue {
  content: string = '';
  async created() {
    const res = await getRule();
    this.content = res.data;
  }
}
